//import { useTranslation } from "react-i18next";

export const AdvancedSettings = () => {
  //const { t } = useTranslation();

  return <div>Hello 👋, I am a AdvancedSettings component.</div>;
};
